<template>
  <footer>
    <div class="foot-nav-container pc_padding">
      <div class="footer-about">
        <div class="footer-item-title">
          About us
        </div>
        <div class="footer-item-content">
          {{ domainConfig['ABOUTUS'] }}
        </div>
      </div>
      <div class="footer-side-row">
        <div class="footer-side-resource">
          <div class="footer-item-title">
            Resources
          </div>
          <div class="footer-item-content resource">
            <a class="footer-item-content-item cursor" :href="getHref('/terms-of-services')">
              Terms of services
            </a>
            <a class="footer-item-content-item cursor" :href="getHref('/privacy-policy')">
              Privacy policy
            </a>
          </div>
        </div>
        <div class="footer-side-contact">
          <div class="footer-item-title">
            Contact us
          </div>
          <div class="footer-item-content">
            <a class="footer-item-content-item"
              :href="`mailto:${domainConfig['IAMEMAIL']}`">{{ domainConfig['IAMEMAIL'] }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="corner-module pc_padding">
      Copyright © 2025 {{ domainConfig['IAmTitle'] }}. All Rights Reserved.
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FootModule1',
  computed: {
    ...mapGetters(["domainConfig"]),
  },
  methods: {
    getHref (path) {
      const currentParams = this.$router.currentRoute.params;
      const currentQuery = this.$route.query;
      const channel = currentParams.channel ? `/${currentParams.channel}` : '';
      const queryString = new URLSearchParams(currentQuery).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';
      return `${channel}${path}${fullQueryString}`;
    },
  },
};
</script>
